import { View, StyleSheet } from 'react-native';
import TextLato from '../text/text-lato/TextLato';
import { useStore } from 'src/contexts/StoreContext';
import { neutrals } from 'src/theme/colors';

const LandscapeOverlay = () => {
  const { i18n } = useStore();
  return (
    <View style={styles.overlay}>
      <TextLato style={styles.overlayText}>{i18n.t('rotate_to_portrait:message')}</TextLato>
    </View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    color: neutrals.black,
    backgroundColor: neutrals.coldGrays.pearl,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  overlayText: {
    color: neutrals.neutralGrays.tarmac,
    fontSize: 20,
  },
});

export default LandscapeOverlay;
